import { InboxMetricsOverview } from "../molecules/InboxMetricsOverview";

import { Overview } from "../molecules/Overview";

export const InboxCard = () => (
  <div className="flex flex-col h-full">
    <Overview />
    <InboxMetricsOverview />
  </div>
);
